export enum DialogType {
  Contact = 'contact',
  Download = 'download',
}
